import React from 'react';
import { Chip, Divider } from '@mui/material';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import { NodeViewWrapper, ReactNodeViewProps } from '@tiptap/react';
import { useGnContext } from '../GnContext';

/**
 * A page boundary (spec 046 US3). In canvas view it renders as a subtle labeled divider;
 * in paged view GnNotebook windows the document to one page at a time and this node's own
 * boundary marking is redundant, so it renders nothing there. Presentation only — the
 * node's mere presence in the doc is what makes storage view-independent (FR-031).
 */
const PageBreakDividerNode: React.FC<ReactNodeViewProps> = ({ node }) => {
  const { label } = node.attrs as { label: string };
  const { viewPref } = useGnContext();

  if (viewPref === 'PAGES') {
    return <NodeViewWrapper as="div" data-gn-page-break-view style={{ display: 'none' }} />;
  }

  return (
    <NodeViewWrapper as="div" data-gn-page-break-view>
      <Divider sx={{ my: 2 }}>
        <Chip
          icon={<AutoStoriesIcon sx={{ fontSize: '14px !important' }} />}
          label={label || 'Page break'}
          size="small"
          variant="outlined"
          sx={{ height: 22, fontSize: '0.7rem', color: 'text.secondary' }}
        />
      </Divider>
    </NodeViewWrapper>
  );
};

export default PageBreakDividerNode;
